import utils from '@/js/utils';
import MENU_USE_ASSET from '@/configs/menus/asset_governance.menu';
import { ROLES_LIST } from '@/js/constants';
export default [{
  path: '/asset-governance/reports',
  name: 'asset_governance_reports',
  component: function component() {
    return import(/* webpackChunkName: "apps-use-metrics" */'@/apps/asset-governance/pages/ReportsComponent.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('asset_governance_reports', MENU_USE_ASSET)
  }
}, {
  path: '/asset-governance/maintenance',
  name: 'asset_governance_maintenance',
  component: function component() {
    return import(/* webpackChunkName: "apps-use-metrics" */'@/apps/asset-governance/pages/MaintenanceComponent.vue');
  },
  meta: {
    corporate: true,
    authentified: utils.getPermissiosInMenuDict('asset_governance_maintenance', MENU_USE_ASSET)
  }
}];